import { Divider, Image } from 'antd';
import axios from 'axios';
import parse from 'html-react-parser';
import React, { useEffect, useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import DOMPurify from 'dompurify';
import css from './Posts.module.css';
import orn from './../../../assets/images/ornament.svg';

function SinglePost() {
    let [post, setPost] = useState({ body: '' })
    let [created, setCreated] = useState(null)
    let [error, setError] = useState(null)
    let params = useParams()
    useEffect(() => {
        window.scrollTo(0, 0)
        axios.get('/singlepost/' + params.id)
            .then(res => {
                setPost(res.data)
                setCreated(new Date(res?.data?.created_at))
                setError(null)
            })
            .catch(err => {
                console.error('Maqola yuklashda xatolik:', err)
                setError('Maqolani yuklashda xatolik yuz berdi')
            })
    }, [params.id])
    return (
        <>
            {error && (
                <div style={{
                    padding: '16px',
                    backgroundColor: '#fee2e2',
                    color: '#dc2626',
                    borderRadius: '8px',
                    marginBottom: '20px'
                }}>
                    {error}
                </div>
            )}
            {!error && post.title && (
            <>
            <div className={css.intro} style={{
                backgroundImage: 'url(' + orn + ')',
                backgroundColor: '#fff',
                padding: '20px',
                borderRadius: '25px',
                boxShadow: '0px 0px 15px -4px gray',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundSize: 'cover'
            }}>
                <Row className='mt-3'>
                    <Col md={6}>
                        <p>{post.category}</p>
                        <Image src={post.img} height={250} />
                    </Col>
                    <Col md={6}>
                        <h1>{post.title}</h1>
                        <Divider />
                        <p>{`Joylangan vaqti: ${created?.getDate() || '—'} / ${(created?.getMonth() || 0) + 1} / ${created?.getFullYear() || '—'} yil`}</p>
                        <Divider />
                        {post.pdf && <Button onClick={() => window.open(post.pdf)}>PDF fayli bilan tanishish</Button>}
                    </Col>
                </Row>
            </div>
            <Divider />
            <div style={{
                padding: '25px',
                backgroundColor: '#fff',
                borderRadius: '20px',
                boxShadow: '0px 0px 15px -4px gray'
            }}>
                {parse(DOMPurify.sanitize(post.body))}
            </div>
            </>
            )}
        </>
    );
}

export default SinglePost;